import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  VEHICLE_VALUATION_COST_WARRANTY_API_PATH,
  VEHICLE_VALUATION_COST_WARRANTY_RESOURCE,
  type VehicleValuationCostWarrantyCreateBody,
  type VehicleValuationCostWarrantyCreateResponse,
} from "./vehicle-valuation-cost-warranty.types";

export function useVehicleValuationCostWarrantyCreateMutation() {
  const queryClient = useQueryClient();

  return useMutation<VehicleValuationCostWarrantyCreateResponse, Error, VehicleValuationCostWarrantyCreateBody>({
    mutationFn: async (body) => {
      const response = await alphartisApiAxios.post<VehicleValuationCostWarrantyCreateResponse>(
        VEHICLE_VALUATION_COST_WARRANTY_API_PATH,
        body,
      );

      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [VEHICLE_VALUATION_COST_WARRANTY_RESOURCE],
      });
    },
  });
}
